import React from 'react'
import DataLoader from '../features/heatmap/DataLoader'

const Heatmap = () => (
    <div>
        <DataLoader />
    </div>
)

export default Heatmap